const cargoQuantityUnits = [
    { id: 1, value: 'MTS', label: 'MTS' },
    { id: 2, value: 'CBM', label: 'CBM' },
];

export default cargoQuantityUnits;
